"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingRuleCreateButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const setRules_json_1 = __importDefault(require("@framework/abis/json/Staking/setRules.json"));
const setRules_json_2 = __importDefault(require("@framework/abis/json/StakingPetami/setRules.json"));
const provider_user_1 = require("@dzambalaorg/provider-user");
const constants_1 = require("@framework/constants");
const utils_1 = require("@framework/utils");
const dialogs_1 = require("../../../../dialogs");
// import { stakingCreateValidationSchema } from "./upload-dialog/validation";
const initialValues = {
    deposit: mui_inputs_asset_1.emptyPrice,
    reward: mui_inputs_asset_1.emptyPrice,
    durationAmount: 2592000,
    durationUnit: types_1.DurationUnit.DAY,
    penalty: 100,
    maxStake: 0,
    recurrent: false,
    advance: false,
};
const StakingRuleCreateButton = (props) => {
    const { className, disabled, variant = styled_1.ListActionVariant.button } = props;
    const user = (0, provider_user_1.useUser)();
    const profile = user.profile;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { execute: metaLoadRule } = (0, react_hooks_eth_1.useMetamask)(async (rule, content) => {
        const stakingRule = {
            deposit: rule.deposit?.components.sort((0, utils_1.sorter)("contract.id")).map(component => ({
                tokenType: Object.values(types_1.TokenType).indexOf(component.tokenType),
                token: component.contract.address,
                tokenId: component.tokenType === types_1.TokenType.ERC1155 && component.template.tokens
                    ? component.template?.tokens[0].tokenId
                    : component.templateId || 0,
                amount: component.amount,
            })),
            reward: rule.reward
                ? rule.reward.components.map(component => ({
                    tokenType: Object.values(types_1.TokenType).indexOf(component.tokenType),
                    token: component.contract.address,
                    tokenId: component.tokenType === types_1.TokenType.ERC1155 ? component.template?.tokens[0].tokenId : component.templateId,
                    amount: component.amount,
                }))
                : [],
            content,
            terms: {
                period: rule.durationAmount, // todo fix same name // seconds in days
                penalty: rule.penalty || 0,
                maxStake: rule.maxStake,
                recurrent: rule.recurrent,
                advance: rule.advance,
            },
            active: true, // todo add var in interface
        };
        return writeContractAsync({
            address: rule.contract.address,
            abi: profile.merchantId === constants_1.petamiMerchantId ? setRules_json_2.default : setRules_json_1.default,
            functionName: "setRules",
            args: [[stakingRule]],
        });
    });
    const handleLoadRule = async ({ data: rule }) => {
        return metaLoadRule(rule, []);
    };
    const handleUpload = () => {
        openDialog(dialogs_1.GlobalDialogKeys.STAKING_RULE_CREATE, initialValues, {
            initialValues: initialValues,
            // validationSchema: stakingCreateValidationSchema,
            message: "dialogs.create",
            testId: "StakingDialogForm",
            onExternalConfirm: handleLoadRule,
            prepareInitialValues: ({ contract, penalty, recurrent, advance, deposit, reward, maxStake, durationAmount, durationUnit, }) => ({
                deposit,
                reward,
                penalty,
                recurrent,
                advance,
                durationAmount,
                durationUnit,
                contract,
                maxStake,
            }),
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleUpload, icon: icons_material_1.Add, message: "form.buttons.create", className: className, dataTestId: "StakingRuleUploadButton", disabled: disabled, variant: variant }));
};
exports.StakingRuleCreateButton = StakingRuleCreateButton;
//# sourceMappingURL=index.js.map